function findLogo(e) {
    if (e.target.closest('[data-cm-modal-btn]')) {
        //find modal div
    var modal = document.getElementById('modal')

    if (modal) {
        var trustedsiteLogo = modal.querySelector('.trustedsite-trustmark');
        //found the logo
        if (trustedsiteLogo) {
            //force the re-init
            trustedsiteLogo.classList.remove('loaded')
        }
    }
    }
}

document.addEventListener('click', findLogo);
